import React, { useRef, useEffect } from 'react';
import styles from '@/styles/ModalSlider.module.css';
import { CloseButton } from '@/components/common/CloseButton';
interface FullscreenVideoProps {
  src: string;
  onClose: () => void;
}

const FullscreenVideo: React.FC<FullscreenVideoProps> = ({ src, onClose }) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  const handleClose = () => {
    videoRef.current?.pause();
    onClose();
  };

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  useEffect(() => {
    // Lock scroll only — do NOT call history.pushState.
    // Manual pushState desyncs the Next.js Pages Router so later soft
    // navigations can update the URL while the page UI stays stuck.
    document.body.classList.add('overflow-hidden');

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        handleClose();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.classList.remove('overflow-hidden');
      window.removeEventListener('keydown', handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className='fixed inset-0 bg-black bg-opacity-90 z-[105] flex items-center justify-center !m-0'
      onClick={handleOverlayClick}
    >
      <div className='fixed md:top-4 md:right-4 top-1 right-1 z-[106]'>
        <CloseButton
          onClick={handleClose}
          size={20}
          ariaLabel='Close video'
          variant='white'
          className={styles.closeButton}
        />
      </div>
      <video
        ref={videoRef}
        src={src}
        autoPlay
        controls
        playsInline
        webkit-playsinline='true'
        x-webkit-airplay='allow'
        className='w-full max-w-6xl h-auto max-h-[90vh] rounded-xl shadow-lg'
        style={{
          WebkitUserSelect: 'none',
          WebkitTouchCallout: 'none',
        }}
      />
    </div>
  );
};

export default FullscreenVideo;
